import { style } from "typestyle";
import { FONT_MAIN, FONT_WEIGHT_MEDIUM, FONT_WEIGHT_REGULAR } from "../../../constants";

export const textClassName = style({
  fontFamily: FONT_MAIN,
  fontSize: '14px',
  lineHeight: '20px',
});

export const textWeightRegularClassName = style({
  fontWeight: FONT_WEIGHT_REGULAR,
});

export const textWeightMediumClassName = style({
  fontWeight: FONT_WEIGHT_MEDIUM,
});
